import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "fill-height",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "8"
    }
  }, [_c(VTabs, {
    model: {
      value: _vm.tabs,
      callback: function ($$v) {
        _vm.tabs = $$v;
      },
      expression: "tabs"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _vm.stateIsNumber ? _c(VTab, {
    class: `${_vm.color}--text`,
    attrs: {
      "href": "#tab-chart"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3",
    attrs: {
      "size": "20",
      "color": _vm.color
    }
  }, [_vm._v("fal fa-chart-line")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.chart')) + "\n        ")], 1) : _vm._e(), _c(VTab, {
    class: `${_vm.color}--text`,
    attrs: {
      "href": "#tab-table"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3",
    attrs: {
      "size": "20",
      "color": _vm.color
    }
  }, [_vm._v("fal fa-table")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.chartOptions.table')) + "\n        ")], 1)], 1)], 1), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('core-date-time-picker-flat', {
    staticClass: "mt-0",
    attrs: {
      "isRange": "",
      "initialRange": "now-24h"
    },
    on: {
      "date:picked": _vm.handleDatePicked
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTabsItems, {
    model: {
      value: _vm.tabs,
      callback: function ($$v) {
        _vm.tabs = $$v;
      },
      expression: "tabs"
    }
  }, [_vm.stateIsNumber ? _c(VTabItem, {
    attrs: {
      "value": "tab-chart"
    }
  }, [_vm.chartData.hasDataWithTooManyItems ? _c('div', [_c('core-n20Card', {
    staticClass: "dt-card-text-01"
  }, [_c(VCardTitle, {
    staticClass: "pa-0"
  }, [_c(VIcon, {
    staticClass: "mr-3",
    attrs: {
      "size": "20",
      "color": "niotix",
      "left": ""
    }
  }, [_vm._v("fal fa-info-circle")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.chartOptions.displayLimitTitle')) + "\n              ")], 1), _c(VCardText, {
    staticClass: "pa-0"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.chartOptions.displayLimitText')) + "\n              ")])], 1)], 1) : _vm._e(), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('core-chart-history-state-line', {
    class: {
      'chart-empty': _vm.isEmptyChart
    },
    attrs: {
      "chart-data": _vm.chartData,
      "interval": _vm.interval,
      "height": 400,
      "config": _vm.chartConfig
    }
  }), _vm.isEmptyChart ? _c('div', {
    staticClass: "chart-empty-text"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")]) : _vm._e(), _vm.hasChartError ? _c('div', {
    staticClass: "chart-empty-text"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.errorWhileFetchingData')) + "\n            ")]) : _vm._e()], 1), _c(VForm, {
    ref: "stateHistoryForm",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c(VRow, {
    staticClass: "mt-4"
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "4"
    }
  }, [_c(VSelect, {
    attrs: {
      "disabled": _vm.rawData,
      "items": _vm.items,
      "item-text": "time",
      "item-value": "timeVal",
      "single-line": "",
      "label": _vm.$i18n_t('Common.chartOptions.interval'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.interval,
      callback: function ($$v) {
        _vm.interval = $$v;
      },
      expression: "interval"
    }
  })], 1), _c(VCol, {
    staticClass: "d-flex justify-space-between",
    attrs: {
      "cols": "12",
      "md": "10",
      "sm": "8"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "ml-0"
  }, [_c(VCheckbox, {
    attrs: {
      "disabled": _vm.shouldOptionCheckboxBeDisabled('latest'),
      "label": _vm.$i18n_t('Common.chartOptions.latest'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.latest,
      callback: function ($$v) {
        _vm.latest = $$v;
      },
      expression: "latest"
    }
  })], 1), _c('div', {
    staticClass: "ml-5"
  }, [_c(VCheckbox, {
    attrs: {
      "disabled": _vm.shouldOptionCheckboxBeDisabled('min'),
      "label": _vm.$i18n_t('Common.chartOptions.min'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.min,
      callback: function ($$v) {
        _vm.min = $$v;
      },
      expression: "min"
    }
  })], 1), _c('div', {
    staticClass: "ml-5"
  }, [_c(VCheckbox, {
    attrs: {
      "disabled": _vm.shouldOptionCheckboxBeDisabled('max'),
      "label": _vm.$i18n_t('Common.chartOptions.max'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.max,
      callback: function ($$v) {
        _vm.max = $$v;
      },
      expression: "max"
    }
  })], 1), _c('div', {
    staticClass: "ml-5"
  }, [_c(VCheckbox, {
    attrs: {
      "disabled": _vm.shouldOptionCheckboxBeDisabled('average'),
      "label": _vm.$i18n_t('Common.chartOptions.average'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.average,
      callback: function ($$v) {
        _vm.average = $$v;
      },
      expression: "average"
    }
  })], 1), _c('div', {
    staticClass: "ml-5"
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "label": _vm.$i18n_t('Common.chartOptions.raw'),
      "color": _vm.color,
      "hide-details": "",
      "inset": ""
    },
    model: {
      value: _vm.rawData,
      callback: function ($$v) {
        _vm.rawData = $$v;
      },
      expression: "rawData"
    }
  })], 1)])]), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    class: {
      'd-flex': true,
      'ml-5': _vm.$vuetify.breakpoint.mdAndUp,
      'justify-end': _vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('div', {
    staticClass: "ml-0"
  }, [_c(VCheckbox, {
    attrs: {
      "label": _vm.$i18n_t('Common.chartOptions.chartlines'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.chartLinesCurved,
      callback: function ($$v) {
        _vm.chartLinesCurved = $$v;
      },
      expression: "chartLinesCurved"
    }
  })], 1), _c('div', {
    staticClass: "ml-5"
  }, [_c(VCheckbox, {
    attrs: {
      "label": _vm.$i18n_t('Common.chartOptions.chartOmitNull'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.chartOmitNull,
      callback: function ($$v) {
        _vm.chartOmitNull = $$v;
      },
      expression: "chartOmitNull"
    }
  })], 1)])]), _c(VRow)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _c(VTabItem, {
    attrs: {
      "value": "tab-table"
    }
  }, [_c(VDataTable, {
    attrs: {
      "loading": _vm.isLoadingTable,
      "items": _vm.packetHistory,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooterProps,
      "expanded": _vm.expandedEvent,
      "show-expand": _vm.state.properties.valueType === 'json',
      "single-expand": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:expanded": function ($event) {
        _vm.expandedEvent = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.time",
      fn: function ({
        item
      }) {
        return [_vm._v("\n              " + _vm._s(_vm.localizeDate(item.time)) + "\n            ")];
      }
    }, {
      key: "item.value",
      fn: function ({
        item
      }) {
        return [_vm.state.properties.valueType === 'json' ? [_vm._v(">> JSON")] : [_vm._v(_vm._s(item.value))]];
      }
    }, {
      key: "expanded-item",
      fn: function ({
        headers,
        item
      }) {
        return [_c('td', {
          attrs: {
            "colspan": headers.length,
            "data-cy": `history_state_value_${item.key}`
          }
        }, [_c('codemirror', {
          attrs: {
            "options": _vm.cmOptions,
            "value": _vm.outputValue(item.value)
          }
        })], 1)];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                  " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n                ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.hasTableError ? _vm.$i18n_t('Common.errorWhileFetchingData') : _vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n              ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };